<template>
	<div align="center" class="mt-5">
		<br /><br />
		<v-icon size="70" color="primary">mdi-weather-partly-snowy-rainy</v-icon>
		<h1>¡Ups!</h1>
		<p>Nada que mostrar</p>
		<p>¡Vuelve pronto!</p>
	</div>
</template>

<script>
export default {};
</script>
